import React from 'react';

import {StudyType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {getEnabledStudyTypes, getStudyTypeText} from 'studies/TypedStudyUtils';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';
import SettingsField, {SettingsLabel} from 'ui-library/SettingsField';

export interface StudySchemaTypeDropdownProps {
  value: StudyType | null;
  onChange: (studyType: StudyType) => void;
  isBeingCreated: boolean;
}

export default function StudySchemaTypeDropdown(props: StudySchemaTypeDropdownProps): JSX.Element {
  return props.isBeingCreated ? (
    <div>
      <SettingsLabel isRequired={true} label="Study Type" withBottomMargin={true} />
      <SelectDropdown
        displayName={props.value ? getStudyTypeText(props.value) : ''}
        dataTestAttrs={{
          component: 'StudySchemaGeneralSettingsEditor',
          element: 'studySchemaTypeDropdown',
        }}
        menu={
          <Menu value={props.value} scrollable={true} height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.LARGE}>
            {getEnabledStudyTypes().map((studyType) => (
              <Option
                key={studyType}
                value={studyType}
                onSelect={() => {
                  props.onChange(studyType);
                }}
              >
                {getStudyTypeText(studyType)}
              </Option>
            ))}
          </Menu>
        }
      />
    </div>
  ) : (
    <SettingsField
      label="Study Type"
      name="Study Type"
      value={props.value ? getStudyTypeText(props.value) : ''}
      isBeingCreated={false}
      isRequired={true}
      isWritable={false}
      onChange={() => {}}
    />
  );
}
